module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/2d3b6fa2fd60b0c81e2ffce6899b5c1f.png";